module.exports = __webpack_public_path__ + "static/media/settings.f262844a.svg";